import { Box, Button, Divider, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";

import StyledLargeButton from "components/Styled/Button/StyledLargeButton";
import { isPage } from "utils/general";

interface Props {
  handleBack: () => void;
  handleNext?: () => void;
  nextLoading?: boolean;
  nextDisabled?: boolean;
  nextWording?: string | JSX.Element;
  nextIcon?: string;
}
const StepperFooter = ({
  handleBack,
  handleNext,
  nextDisabled,
  nextLoading,
  nextWording = "Next",
  nextIcon = "fa-regular fa-arrow-circle-right",
}: Props) => {
  const navigate = useNavigate();
  const isProOnboarding = isPage(routes.onboardingPro);

  return (
    <>
      <Divider sx={{ my: 3 }} />

      <Grid
        container
        sx={{
          px: 3,
          pb: 3,
          display: "flex",
          justifyContent: isProOnboarding ? "space-between" : "center",
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", gap: 2 }}>
          <StyledLargeButton onClick={handleBack} color="secondary">
            Back
          </StyledLargeButton>
          {isProOnboarding && (
            <Button
              sx={{ color: "purple.dark" }}
              onClick={() => navigate(`/${routes.onboardingProComplete}`)}
            >
              Skip
            </Button>
          )}
        </Box>
        {handleNext && nextWording && (
          <StyledLargeButton
            loading={nextLoading}
            disabled={nextDisabled}
            styles={{ px: 6 }}
            onClick={handleNext}
          >
            {nextWording}
            <Box component="i" className={nextIcon} sx={{ ml: 1 }} />
          </StyledLargeButton>
        )}
      </Grid>
    </>
  );
};

export default StepperFooter;
